<template>
  <div class="article-container">
    <div style="height: 100px;">
      <img src="../assets/img/index/header/022.png">
    </div>
    <div class="content">
      <h3>“科创板八条”</h3>
      <div class="text-body">
        <p>中国证监会不久前发布《关于深化科创板改革  服务科技创新和新质生产力发展的八条措施》，进一步深化改革，提升科创板对新产业新业态新技术的包容性，发挥资本市场功能。</p>
        <p>措施主要包括：</p>
        <p>一、强化科创板“硬科技”定位。严把入口关，进一步完善科技型企业精准识别机制，支持优质未盈利科技型企业在科创板上市。</p>
        <p>二、开展深化发行承销制度试点。优化新股发行定价机制，完善科创板新股市值配售安排，加强询报价行为监管。</p>
        <p>三、优化科创板上市公司股债融资制度。建立健全开展关键核心技术攻关的“硬科技”企业股债融资、并购重组“绿色通道”，探索建立“轻资产、高研发投入”认定标准，推动再融资储架发行试点案例率先在科创板落地。</p>
        <p>四、更大力度支持并购重组。支持科创板上市公司开展产业链上下游的并购整合，提高并购重组估值包容性，丰富并购重组支付工具，支持科创板上市公司聚焦做优做强主业开展吸收合并。</p>
        <p>五、完善股权激励制度。提高股权激励精准性，完善科创板上市公司股权激励实施程序。</p>
        <p>六、完善交易机制。加强交易监管，丰富科创板指数、ETF品类及ETF期权产品。</p>
        <p>七、加强科创板上市公司全链条监管。从严打击科创板欺诈发行、财务造假等市场乱象，引导创始团队、技术骨干等自愿延长股份锁定期限，优化私募股权创投基金退出“反向挂钩”制度，严格执行退市制度。</p>
        <p>八、积极营造良好市场生态。推动优化科创板司法保障制度机制，加强与地方政府、相关部委协作，深入实施“提质增效重回报”行动。</p>
        <div class="align-right">
          <p>引用内容来源：<el-link style="margin-top: -3px;" href="http://yn.people.com.cn/n2/2024/0708/c372455-40904429.html" type="primary">人民网《八条措施深化科创板改革》</el-link></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default{
    data() {
      return{

      }
    }
  }
</script>
<style scoped>
.article-container {
    max-width: 900px;
    margin: 0 auto;
    padding: 2rem;
}

.header-image img {
    width: 100%;
    height: auto;
    display: block;
    margin-bottom: 1.5rem;
    font-size: 27px;
}

.content {
    text-align: justify;
    line-height: 1.6;
    font-size: 30px;
}

.text-body p {
    margin-bottom: 1rem;
    font-size: 30px;
}

h3 {
    font-size: 2rem;
    margin-bottom: 1rem;
    text-align: center;
}
.align-right{
  text-align: right;
  font-size: 30px;
}
.text-body p {
    margin-bottom: 1rem;
    font-size: 1rem !important; /* 添加这一行来强制覆盖 */
    font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/batiao.vue